export default "__VITE_ASSET__IPIuNLiu__"